<template>
  <div></div>
</template>

<script>
import router from '@/router'

export default {
  name: 'Signup',
  data: () => ({
    loadingRequest: false,
    user: JSON.parse(localStorage.getItem('currentUser'))
  }),

  methods: {
    redirect () {
      router.push({
        name: 'Account',
        params: {
          id: this.user._id,
          completeAccount: true
        }
      })
    }
  },

  mounted () {
    this.redirect()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Signup.vue